import React from 'react';
import { HighlightLabel, PricingCardContainer } from './PricingCard.styles';
import Typography from 'src/app/atoms/Typography/Typography';
import { IPricingCard } from 'src/hooks/usePricingCards';
import PriceBlock from './PriceBlock';
import FeatureBlockList from './FeatureBlockList';
import useOnMobile from 'src/hooks/useOnMobile';
import { cssVar } from 'src/app/styles/helper';

export interface PricingCardProps extends IPricingCard {
  priceBlockMinHeight?: number;
  withBannerSpacing?: boolean;
  hidePlanTitle?: boolean;
}

const PricingCard = ({
  planTitle,
  supportingText,
  price,
  featureBlocks,
  bannerText,
  callToAction,
  priceBlockMinHeight,
  pricePeriodText,
  withBannerSpacing = true,
  hidePlanTitle = false,
  background = 'bg-secondary-alt',
  cardBorder = 'border-secondary-alt',
  priceBlockBorder = 'border-secondary',
}: PricingCardProps): JSX.Element => {
  const isMobile = useOnMobile(640);

  const align = isMobile ? 'center' : 'left';
  const paddingTop = (isMobile && !bannerText) || !withBannerSpacing ? 'spacing-none' : 'spacing-6xl';

  return (
    <PricingCardContainer
      direction='column'
      borderRadius='radius-2xl'
      overflow='hidden'
      paddingTop={paddingTop}
      position='relative'
      border={`1px solid ${cssVar(cardBorder)}`}
      background={background}
    >
      {bannerText && (
        <HighlightLabel
          justify='center'
          align='center'
          background={bannerText.background || 'bg-brand-solid'}
        >
          <Typography
            type='paragraph'
            size='sm'
            fontWeight='font-weight-semibold'
            color='text-white'
          >
            {bannerText.text}
          </Typography>
        </HighlightLabel>
      )}
      <PriceBlock
        planTitle={planTitle}
        supportingText={supportingText}
        price={price}
        callToAction={callToAction}
        align={align}
        minHeight={priceBlockMinHeight}
        hidePlanTitle={hidePlanTitle}
        pricePeriodText={pricePeriodText}
        priceBlockBorder={priceBlockBorder}
      />
      <FeatureBlockList featureBlocks={featureBlocks} />
    </PricingCardContainer>
  );
};

export default PricingCard;
